import SectionSummary from './SectionSummary.component';

export default SectionSummary;
